import { TableRow, TableCell, Typography, Button } from '@mui/material';

// ----------------------------------------------------------------------

export default function GamePlaylistTableRow({ row, rowNumber, selectContentHandler }) {
  const { GameJoinApplicationPlayListID, GameJoinApplicationPlayListLabel } = row;

  return (
    <TableRow hover>
      <TableCell align="center">
        <Typography variant="body1">{rowNumber}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{GameJoinApplicationPlayListLabel}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{GameJoinApplicationPlayListID}</Typography>
      </TableCell>

      <TableCell align="right">
        <Button color="warning" variant="contained" onClick={() => selectContentHandler(row)}>
          انتخاب
        </Button>
      </TableCell>
    </TableRow>
  );
}
